function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_UIPREFERENCESBYUSERID_REQUEST = "GET_UIPREFERENCESBYUSERID_REQUEST";
export var GET_UIPREFERENCESBYUSERID_SUCCESS = "GET_UIPREFERENCESBYUSERID_SUCCESS";
export var GET_UIPREFERENCESBYUSERID_FAILURE = "GET_UIPREFERENCESBYUSERID_FAILURE";
export var RESET_GET_UIPREFERENCESBYUSERID = "RESET_GET_UIPREFERENCESBYUSERID";

// Fetches a particular user from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
var fetchUiPreferencesByUserId = function fetchUiPreferencesByUserId(userId) {
  var queryString = urlSearchParams({
    userId: userId,
    projection: "full"
  });
  return _defineProperty({
    userId: userId
  }, CALL_API, {
    types: [GET_UIPREFERENCESBYUSERID_REQUEST, GET_UIPREFERENCESBYUSERID_SUCCESS, GET_UIPREFERENCESBYUSERID_FAILURE],
    endpoint: "uiPreferences/search/findByUserId".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};

//Fetches a particular user by email from Front API unless it is cached.
//Relies on Redux Thunk middleware.
export var loadUiPreferencesByUserId = function loadUiPreferencesByUserId(userId, forceUpdate) {
  return function (dispatch, getState) {
    var uiPreferences = getState().entities.uiPreferences.byUserId[userId];
    if (uiPreferences && !forceUpdate) return null;
    var call = getState().apiCalls.loadUiPreferencesByUserId[userId];
    if (call && call.isFetching) return null;
    return dispatch(fetchUiPreferencesByUserId(userId));
  };
};
export var POST_UIPREFERENCES_REQUEST = "POST_UIPREFERENCES_REQUEST";
export var POST_UIPREFERENCES_SUCCESS = "POST_UIPREFERENCES_SUCCESS";
export var POST_UIPREFERENCES_FAILURE = "POST_UIPREFERENCES_FAILURE";
export var RESET_POST_UIPREFERENCES = "RESET_POST_UIPREFERENCES";
export var postUiPreferences = function postUiPreferences(uiPreferences) {
  return _defineProperty({}, CALL_API, {
    types: [POST_UIPREFERENCES_REQUEST, POST_UIPREFERENCES_SUCCESS, POST_UIPREFERENCES_FAILURE],
    endpoint: "uiPreferences/".concat(uiPreferences.userId),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(uiPreferences),
      credentials: "same-origin"
    }
  });
};
export var postUiPreferencesFailure = function postUiPreferencesFailure(message) {
  return {
    response: {
      message: message
    },
    type: POST_UIPREFERENCES_FAILURE
  };
};
export var resetPostUiPreferences = function resetPostUiPreferences() {
  return {
    type: RESET_POST_UIPREFERENCES
  };
};